import { useEffect, useState } from "react";
import { getDynamicData } from "~/common/Store/actions/updateUserAndChatFromOrigin";

export function useDynamicData() {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    getDynamicData.then((result) => {
      if (result.isError) return;
      setIsInitialized(true);
    });
  }, []);

  return isInitialized;
}
